import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import {
	PaginatedVendorResponse,
	VendorSearchCriteria
} from "../../definitions/api/mp-common/vendor-search";
import { VendorParams } from "../../definitions/api/shared/vendor-params";
import { Vendor } from "../../definitions/vendor";
import { TypedAppConfigService } from "../typed-app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class MpCommonServiceV2 extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: TypedAppConfigService
	) {
		super("mpapi", appConfigService.getConfigValue("API_ENDPOINT"));
	}

	searchVendors(criteria: VendorSearchCriteria = {}): Observable<PaginatedVendorResponse> {
		return this.api.post<PaginatedVendorResponse>(
			this.url("/vendor/search"),
			criteria,
			"errors.search-vendors-failed"
		);
	}

	activeVendors(params?: VendorParams): Observable<Vendor[]> {
		const criteria: VendorSearchCriteria = {};
		if (params?.id) {
			criteria.id = params.id;
		}
		return this.searchVendors(criteria).pipe(map((response) => response.items ?? []));
	}
}
